import { withStyles } from 'vopay';
import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ResetPasswordForm from './ResetPasswordForm';
import usePostPortalResetPassword from '@/hooks/useApi/usePostPortalResetPassword';
import styles from '../Login.module.scss';

const cn = withStyles(styles);

export default function ResetPasswordPage() {
  const history = useHistory();
  const { PasswordToken } = useParams<{ PasswordToken: string }>();
  const [postostPortalResetPasswordResponse, postPortalResetPassword] = usePostPortalResetPassword({});
  const [passwordErrorMsg, setPasswordErrorMsg] = useState('');
  const [passwordError, setPasswordErorr] = useState(false);

  useEffect(() => {
    if (postostPortalResetPasswordResponse?.Success) {
      history.push('/');
    } else if (postostPortalResetPasswordResponse) {
      setPasswordErorr(true);
      setPasswordErrorMsg(postostPortalResetPasswordResponse.ErrorMessage);
    }
  }, [postostPortalResetPasswordResponse]);

  // Same wrapper as Login so the card's Inter font and input sizing apply on this route too.
  return (
    <div className={cn('loginContainerInner')}>
      <ResetPasswordForm
        onSubmit={(values, actions) => {
          postPortalResetPassword({
            Password: values.Password,
            PasswordToken: PasswordToken || '',
          });

          actions.setSubmitting(false);
        }}
        hasError={passwordError}
        errorMsg={passwordErrorMsg}
        initialValues={{ Password: '' }}
      />
    </div>
  );
}
